var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop"}},[_c('span',{staticClass:"svg-icon svg-icon-light"},[_c('inline-svg',{attrs:{"src":"/media/svg/icons/Navigation/Up-2.svg"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }